import RytmWebflow from 'rytm-webflow'
import { odometer, odometerStart } from '../shared/odometer'

class OdometerController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initOdometers();
  }
  addEventListeners() {
    super.addEventListeners();
    document.addEventListener('scroll', this.onDocumentScroll);
  }
  removeEventListeners() {
    super.removeEventListeners()
    document.removeEventListener('scroll', this.onDocumentScroll);
  }

  onDocumentScroll = (e) => {
    [...document.querySelectorAll('.r-odometer')].forEach( (el, index) => {
      if (RytmWebflow.elementIsVisibleInViewport(el)) {
        odometerStart(el);
      }
    });
  }

  // ### Custom
  initOdometers = () => { 
    [...document.querySelectorAll('.r-odometer')].forEach( (el, index) => {
      // is in viewport?
      const start = RytmWebflow.elementIsVisibleInViewport(el) ? true : false;
      odometer(el, start);
    } )
  }
  

}

export default OdometerController;